/**
* Controla quais scripts do Clarity já foram injetados
*/
window.__clarityTagInjected = window.__clarityTagInjected || {};

/**
 * Injeta o script do Clarity com base no ID fornecido
 * @param {string} clarityId - O ID do Clarity a ser injetado
 * @param {string} tagName - Nome identificador da tag (usado para debug e controle)
 */
const injectClarityScript = (clarityId, tagName) => {
  if (window.__clarityTagInjected[tagName]) {
    console.debug(`Clarity (${tagName}) já injetado.`);
    return;
  }

  window.__clarityTagInjected[tagName] = true;

  (function inject(windowObj, documentObj, globalFn, scriptTag, id, scriptEl, firstScriptEl) {
    windowObj[globalFn] = windowObj[globalFn] || function () {
      (windowObj[globalFn].q = windowObj[globalFn].q || []).push(arguments);
    };

    scriptEl = documentObj.createElement(scriptTag);
    scriptEl.async = true;
    scriptEl.src = "https://www.clarity.ms/tag/" + id;

    firstScriptEl = documentObj.getElementsByTagName(scriptTag)[0];
    if (firstScriptEl && firstScriptEl.parentNode) {
      firstScriptEl.parentNode.insertBefore(scriptEl, firstScriptEl);
    } else {
      console.warn(`Não foi possível injetar o script Clarity (${tagName}).`);
    }
  })(window, document, "clarity", "script", clarityId);

  console.info(`Clarity (${tagName}) injetado.`);
};

/**
 * Injetar script do Clarity para Germini
 */
export const injectCvaleClarity = () => {
  injectClarityScript("r1jq4mhqsp", "cvale");
};

/**
 * Injetar script do Clarity para PocketExpress (ID atualizado)
 */
export const injectPocketExpressClarity = () => {
  injectClarityScript("r1k1c43tx8", "pocketexpress");
};

/**
 * Função principal que decide qual script injetar com base na resposta
 * @param {string} responseData - Valor que indica o cliente/plataforma
 */
export const injectClarityBasedOnResponse = (responseData) => {
  if (!responseData) return;

  switch (responseData.toLowerCase()) {
    case 'cvale':
      injectCvaleClarity();
      break;
    case 'pocketexpress':
      injectPocketExpressClarity();
      break;
    default:
      console.log(`Tipo de conta não reconhecido para Clarity: ${responseData}`);
  }
};
